import React, { useRef, useEffect } from 'react';
import { ReactLenis } from 'lenis/react';
import { gsap } from 'gsap';
import Hero from './pages/Hero';
import AboutSection from './pages/AboutSection';
import HomeAbout from './pages/HomeAbout';
import Experience from './pages/Experience';
import Highlights from './pages/Highlights';
import AudioPlayer from './components/AudioPlayer';

function App() {
  const lenisRef = useRef();

  useEffect(() => {
    function update(time) {
      lenisRef.current?.lenis?.raf(time * 1000);
    }

    gsap.ticker.add(update);

    return () => {
      gsap.ticker.remove(update);
    };
  }, []);

  return (
    <ReactLenis 
      root 
      options={{
        lerp: 0.1,
        duration: 1.2,
        smoothWheel: true,
        autoRaf: false
      }} 
      ref={lenisRef}
    >
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800">
        <Hero />
        <AboutSection />
        <HomeAbout />
        <Experience />
        <Highlights />
        <AudioPlayer />
      </div>
    </ReactLenis>
  );
}

export default App;